import React, { useState } from 'react'
import { IconButton, Collapse } from '@mui/material'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, Flex, Text } from '@fundamentals'
import { Card } from '@common/material'
import { Palette } from '@core/theme/color-palette-siteassist'

type CollapsibleCardProps = {
  title: string
  children: React.ReactNode
  defaultExpanded?: boolean
}

export const CollapsibleCard: React.FC<CollapsibleCardProps> = ({
  title,
  children,
  defaultExpanded = true,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded)

  return (
    <Card
      sx={{
        px: 2.5,
        py: 1.5,
        backgroundColor: Palette.Common.White,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 'none',
      }}
    >
      <Flex justifyContent='space-between' alignItems='center'>
        <Text variant='h6' color='text.primary' sx={{ fontSize: 16 }}>
          {title}
        </Text>
        <IconButton
          size='small'
          onClick={() => setExpanded((v) => !v)}
          sx={{ '&:focus': { outline: 'none' } }}
        >
          {expanded ? (
            <ExpandLessIcon fontSize='small' />
          ) : (
            <ExpandMoreIcon fontSize='small' />
          )}
        </IconButton>
      </Flex>
      <Collapse in={expanded}>
        <Box sx={{ mt: 1.5 }}>{children}</Box>
      </Collapse>
    </Card>
  )
}
